import env from '@repo/env';
import { getProfileToken } from '@repo/transport/token';

import type { OnboardingStepConfig } from '../types';

export const updateOnboardingState = async (
  step: OnboardingStepConfig
): Promise<void> => {
  const data = new FormData();
  data.append('onboardingState', step.name);

  try {
    const authToken = getProfileToken();
    const response = await fetch(`${env.apiUrl}/users/update`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      body: data,
    });

    if (!response.ok) {
      throw new Error(
        `Failed to update onboarding state: ${response.statusText}`
      );
    }
  } catch (error) {
    console.error('Failed to update onboarding state:', error);
  }
};
